import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningDashboardBalanceRoute extends Route {
  @service roadmap;
  @service store;

  model() {
    const scenario_id = this.roadmap.scenario.id;
    return this.store.findRecord('investment-scenario', scenario_id, {
      reload: true,
    });
  }
}

export default instrumentRoutePerformance(PlanningDashboardBalanceRoute);
